import { DISCARDED_RESPONSE_STRINGS } from 'garaje/utils/enums';

import isRemovedString from './is-removed-string';

export default function removedString(value?: string | null): string {
  if (isRemovedString(value)) {
    return DISCARDED_RESPONSE_STRINGS.DISPLAY_TEXT;
  }
  return String(value ?? '');
}
